import { KCL_MENU_HELPEDK, KCL_MENU_HELPIDK } from 'features/common/acl/constants';

export const manualLinks = [
	{
		name: 'NEWS',
		type: 'base',
		acl: KCL_MENU_HELPIDK,
		label: 'site:news',
		link: 'https://idk.generaliceska.cz/prodej/Stranky/JOK_KCL.aspx',
	},
	{
		name: 'INSTRUCTION_IDK',
		type: 'base',
		acl: KCL_MENU_HELPIDK,
		label: 'site:instruction',
		link: 'https://portal.generaliceska.cz/Stranky/KCL_dokumenty.aspx',
	},
	{
		name: 'INSTRUCTION_EDK',
		type: 'base',
		acl: KCL_MENU_HELPEDK,
		label: 'site:instructionEDK',
		link: 'https://gsm-info.generaliceska.cz/Stranky/GEF_KCL.aspx',
	},
	{
		name: 'CRM',
		type: 'additional',
		acl: KCL_MENU_HELPIDK,
		label: 'site:crm',
		link: 'https://idk.generaliceska.cz/prodej/Stranky/CRM_homepage.aspx',
	},
	{
		name: 'CAMPAIGNS',
		type: 'additional',
		acl: KCL_MENU_HELPIDK,
		label: 'site:businessCampaigns',
		link: 'https://idk.generaliceska.cz/prodej/Stranky/Kampane.aspx',
	},
	{
		name: 'CLIENT_WAYS',
		type: 'additional',
		acl: KCL_MENU_HELPIDK,
		label: 'site:clientWays',
		link: 'https://idk.generaliceska.cz/prodej/Stranky/klientska_cesta.aspx',
	},
	{
		name: 'LEAD_MANAGEMENT',
		type: 'additional',
		acl: KCL_MENU_HELPIDK,
		label: 'site:leadManagement',
		link: 'https://idk.generaliceska.cz/prodej/Stranky/LeadManagement.aspx',
	},
	{
		name: 'RETENTION',
		type: 'additional',
		acl: KCL_MENU_HELPIDK,
		label: 'site:retention',
		link: 'https://idk.generaliceska.cz/ostatni/Stranky/retence.aspx',
	},
];
